export const ONE_WORLD_HOST = "lesson.one-world-japan.com";
export const ONE_WORLD_TOP_URL = `https://${ONE_WORLD_HOST}`;

export const BLOB_URL =
    "https://oneworldstorage.blob.core.windows.net/oneworld";

export const appPublicImg = `${BLOB_URL}/publicImg/`;

export const azureUrl = "oneworld20240430100438.azurewebsites.net";

export const lingualNinjaUrl = "https://www.lingual-ninja.com";
